var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.rates),function(rate){return _c('RateRow',{key:rate.id,attrs:{"rate":rate}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }